export const imgApi = `https://imgstore.bangles.org.in`;